// extracted by mini-css-extract-plugin
module.exports = {"upload":"Upload_upload__1v6pN","uploaded":"Upload_uploaded__2TcRZ","dropzone":"Upload_dropzone__2Gh5d"};